import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import SkillAssessment from './skill-assessment';
import CodingAssessment from './coding-assessment';
import { useCandidateProfileContext } from '../hooks/use-candidate-profile-context';
import InteractiveInterview from './interactive-assessment';

const AssessmentPill = ({ selected, label, onClick }) => (
  <Stack
    onClick={onClick}
    sx={{
      cursor: 'pointer',
      width: '184px',
      height: '48px',
      bgcolor: selected
        ? 'background.primaryAccent2'
        : 'background.primaryWhite1',
      '&:hover': {
        bgcolor: 'background.primaryGrey3',
      },
      color: selected ? 'content.accent1' : 'content.primaryBlack1',
      border: '1px solid',
      borderRadius: '42px',
      borderColor: selected
        ? 'background.primaryAccent2'
        : 'border.primaryBlack3',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    {label}
  </Stack>
);

AssessmentPill.propTypes = {
  selected: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default function AiInterviewGroup({ jobId }) {
  // hooks
  const { needCodingAssessment, interactiveInterviewEnabled } =
    useCandidateProfileContext();

  // states
  const [assessment, setAssessment] = useState('skill');

  return (
    <Stack spacing="24px" height="100%">
      {(needCodingAssessment || interactiveInterviewEnabled) && (
        <Stack direction="row" alignItems="center" spacing="10px">
          <AssessmentPill
            selected={assessment === 'skill'}
            label="Skill Assessment"
            onClick={() => {
              setAssessment('skill');
            }}
          />
          {needCodingAssessment && (
            <AssessmentPill
              selected={assessment === 'coding'}
              label="Coding Assessment"
              onClick={() => {
                setAssessment('coding');
              }}
            />
          )}
          {interactiveInterviewEnabled && (
            <AssessmentPill
              selected={assessment === 'interactive'}
              label="Interactive Interview"
              onClick={() => {
                setAssessment('interactive');
              }}
            />
          )}
        </Stack>
      )}
      {assessment === 'skill' && <SkillAssessment jobId={jobId} />}
      {assessment === 'coding' && <CodingAssessment />}
      {assessment === 'interactive' && <InteractiveInterview />}
    </Stack>
  );
}

AiInterviewGroup.propTypes = {
  jobId: PropTypes.string,
};
